import { WebexUser } from '../redux/coachingCenter/types'
import { DropdownListProps } from '../components/EditableDropdown/typings'

const getWebexUsersDropdown = (
  webexUsers: Array<WebexUser>
): Array<DropdownListProps> => {
  const webexUsersDropdown = webexUsers.map((webexUser: WebexUser) => ({
    id: webexUser?.id,
    name: webexUser?.webexUser
  }))
  return webexUsersDropdown
}

export default getWebexUsersDropdown
